import { TFileUpload } from "@/types";

export interface IEditSummaryData {
  title?: string;
  content: IEditSummaryContent[];
}

export interface IEditSummaryContent {
  label: string;
  type: ESummaryContentType;
  content: (string | undefined)[] | TFileUpload[];
}

export enum ESummaryContentType {
  TEXT = "text",
  IMAGE = "image",
  FILE = "file",
}
